import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CategoryState {
  categories: any[]; // ideally strongly type it
  needRefresh: boolean;
}

const initialState: CategoryState = {
  categories: [],
  needRefresh: true,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategories: (state, action: PayloadAction<any[]>) => {
      state.categories = action.payload;
      state.needRefresh = false;
    },
    setNeedRefresh: (state, action: PayloadAction<boolean>) => {
      state.needRefresh = action.payload;
    },
  },
});

export const { setCategories, setNeedRefresh } = categorySlice.actions;
export default categorySlice.reducer;
